<template>
    <div>
        <a-modal v-model="isVisible" :closable="false" title="Cancel Order" on-ok="handleOk">
            <template slot="footer">
                <a-button type="primary" @click="handleBtnUpdate" :loading="isLoading">
                    Update
                </a-button>

                <a-button key="back" @click="handleBtnCancel">
                    Close
                </a-button>
            </template>
            <a-row>
                <a-form-model ref="cancelOrderForm"
                            :model="cancelOrderModel"
                            :rules="cancelOrderRules"
                >
                    <a-row :gutter="[24]">
                       

                        <a-col :span="24">
                            <a-form-model-item label="*Reason" prop="reason" ref="reason">
                                <a-select v-model="cancelOrderModel.reason" @change="handleOptionChanged">
                                    <template v-for="o in reasons">
                                        <a-select-option :value="o.value">
                                            {{ o.label }}
                                        </a-select-option>
                                    </template>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row> 
                    
                    <a-row :gutter="[24]">
                        <a-col :span="24">
                            <a-form-model-item label="Comment" prop="comment" ref="comment">
                               <a-textarea placeholder="Please specify when choose Other" 
                                            :rows="3" 
                                            v-model="cancelOrderModel.comment"
                                            :disabled="cancelOrderModel.reason != 0"
                                />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>
            </a-row>
        </a-modal>
       
    </div>
</template>

<script>
const options = [
    {
        value : 1,
        label : 'Double payment'
    },
    {
        value : 2,
        label : 'Ordered at wrong place'
    },
    {
        value : 3,
        label : 'Not coming to pick up food'
    },
    {
        value : 0,
        label : 'Other'
    }
]
export default {

    data () {
        let checkComment = (rule, value, callback) => {
            console.log('checkcomment is called')
            if(value != null) {
                if (this.cancelOrderModel.reason === 0) {
                    console.log('other is chosen')
                    console.log(value)
                    if(value.length >= 5) {
                        console.log('value is greater than 5')
                        callback();
                    }
                    else {
                        return callback(new Error('Please specify a reason for cancellation! Must be greater than 5'));
                    }
                }
                else {
                    callback();
                }
            }
            else {
                return callback(new Error('Please specify a reason for cancellation! Must be greater than 5'));
            }
            
        };
        return {
            isLoading : false,
            orderId : null,
            reasons : options,
            commentRequired : false,
            cancelOrderModel : {
                reason : null,
                comment : ''
            },
            cancelOrderRules : {
                reason : [
					{
						required : true,
						message : 'Please choose reason'
					}
				],
                comment : [
                    {
                        validator : checkComment,
                        message : 'Please specify a reason for cancellation!',
                        trigger: 'blur',
                        required : this.commentRequired
                    }
                ]
            },
            isVisible : false,
        }
    },
    
    methods : {

        show(record) {
            //console.log(order)
            this.isVisible = true;
            this.orderId = record.orderId;
            //let order = this.$store.getters['orderManager/orderById'](id)
            
        },

        
        handleBtnCancel () {
            this.isVisible = false;
            this.reset();
        },

        handleBtnUpdate() {
           
            this.$message.loading('Updating data...', 5);
            this.isLoading = true;
            this.$refs.cancelOrderForm.validate(async valid => {
                if(valid) {

                    console.log('valid: ' + valid);
                    let record = {
                        orderId : this.orderId,
                        reason : this.getReason()
                    }
                    console.log(record)
                    let isSuccess = await this.$store.dispatch('orderManager/cancelOrderAction', record);

                    if(!isSuccess) {
                        this.isLoading = false;
                        this.$message.error('Something was wrong, please try again!', 5);
                    }
                    else {
                        this.isVisible = false;
                        this.reset();
                    }
                }
                else {
                    console.log('invalid: ' + valid);
                }
                
            })
            
            this.isVisible = false;
            this.reset();
			this.$message.destroy();

        },

      
        reset() {
            this.orderId = null;
            this.cancelOrderModel.reason = null;
            this.cancelOrderModel.comment = '';
            this.isLoading = false;
        },

        handleOptionChanged(e) {
          console.log('handleOptionChanged: ' + e)
          if(e > 0) {
            this.commentRequired = false;
          }
          else {
            this.commentRequired = true;
          }

        },
        getReason() {
            console.log('getReason')
            console.log(this.cancelOrderModel.reason)
            if (this.cancelOrderModel.reason > 0) {
                let index = this.reasons.findIndex(i => { return i.value === this.cancelOrderModel.reason});
                console.log(index)
                if (index > -1) {
                    return this.reasons[index].label;
                }
            }
            else {
                return 'Other: ' + this.cancelOrderModel.comment;
            }

            console.log(this.cancelOrderModel.reason)
            
        }
    }
}
</script>

<style>

</style>